import script from "./BEndComponentInfra.vue?vue&type=script&setup=true&lang=js"
export * from "./BEndComponentInfra.vue?vue&type=script&setup=true&lang=js"

import "./BEndComponentInfra.vue?vue&type=style&index=0&id=711c8b2e&lang=css"

const __exports__ = script;

export default __exports__